import CircleSpinner from 'client/components/misc/CircleSpinner'

const styles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '80vh'
}

const RouteLoading = () => (
  <div style={styles}>
    <CircleSpinner />
  </div>
)

export default RouteLoading
